import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedUserService as AuthenticatedUser } from './auth/auth-guard.service';
import { CallbackComponent } from './callback/callback.component';
import { HomeModule } from '../app/home/home.module';

const ROUTES: Routes = [
	{
		path: '',
		loadChildren: () => import('../app/home/home.module').then(m => m.HomeModule),
		canActivate: [AuthenticatedUser],
	},
	{ path: 'callback', component: CallbackComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(ROUTES, {})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
